export function getCanonicalTitle(guideItem) {
  const categoryTitle = guideItem?.metadata?.properties?.seoInfo?.title;

  // needed because of inconsistencies between how the seo title
  // is returned in category/profile API responses
  const profileTitle = guideItem?.seoInfo?.title;

  return categoryTitle || profileTitle || null;
}
